import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { withRouter } from 'react-router-dom';
import MostSuitableJobsCard from '../shared/mostSuitableJobsCard';
import { withTranslation } from 'react-i18next';

class MostSuitableJobsModal extends Component {
  render() {
    const { t } = this.props;
    return (
      <div>
        <Modal size="xl" isOpen={this.props.showModal} centered>
          <ModalHeader toggle={this.props.onToggle}>
            <em className="fa-2x icon-briefcase mr-2">
              {' '}
              {t('modals.MOST_SUITABLE_CANDIDATES_FOR')} {this.props.mostSuitableJobs.firstName}{' '}
              {this.props.mostSuitableJobs.lastName}
            </em>
          </ModalHeader>
          <ModalBody>
            <div className="col-lg-12">
              {this.props.mostSuitableJobs.applications ? (
                <MostSuitableJobsCard applications={this.props.mostSuitableJobs.applications} />
              ) : (
                ''
              )}
              <Button color="primary" onClick={this.props.onToggle}>
                {t('common.OK')}
              </Button>
            </div>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default withRouter(withTranslation('translations')(MostSuitableJobsModal));
